<script lang="ts" setup>
import { provideInBlockEditor } from '#layers/block-engine/utils/block/editor';

// We need to re-enable the block editor as we may put slot content inside another block
provideInBlockEditor(true);
</script>

<template>
	<BlockInteractiveZone>
		<slot />
	</BlockInteractiveZone>
</template>
